// import { useState } from 'react';
// import { Link, useHistory } from 'react-router-dom';
import PlainGames from '../components/projectGallery/PlainGames'
// import NavBar from '../components/NavBar'
import FooterComp from '../components/FooterComp'
import '../theme/core.css'
import { BgImage25Top } from '../styledComponents/backgroundStyled'
import { BackBorderStyled, GlobalContainer, Gap50, AboutViewText, ProfileAboutStyled, ProfileStyled, TextBorderStyledMainTitle, } from '../styledComponents/globalStyled'
export default function Games() {

    return (
        <>

            <BgImage25Top>
                <ProfileStyled>
                    <TextBorderStyledMainTitle>2D & 3D Games</TextBorderStyledMainTitle><br /><br /><br />
                    <TextBorderStyledMainTitle>I have Developed</TextBorderStyledMainTitle><br />
                </ProfileStyled>
                <BackBorderStyled />
            </BgImage25Top>

            <Gap50 />
            <ProfileAboutStyled>About my 3D and 2D Journery</ProfileAboutStyled>
            <AboutViewText>My journey in 3D and 2D game development has been a dynamic and collaborative adventure. Through the creation of multiple games, both independently and with friends, I've honed my skills in crafting immersive gaming experiences. A significant milestone in this journey was the release of "Soul Labyrinth," marking my debut on the Steam platform. This achievement not only symbolizes a personal milestone but also reflects the dedication and craftsmanship invested in bringing a vision to life.
                <br />
                <br />
                In addition, the collaborative effort on "Neon Runner" stands out as a collective achievement, representing the first release for my team and the game's availability on the Android store. This venture not only underscores my commitment to teamwork but also showcases my versatility in developing games across different platforms. As my 3D and 2D journey continues, these experiences serve as impactful chapters, contributing to the evolution of my skills and the realization of creative aspirations.
            </AboutViewText>
            <Gap50 />

            <GlobalContainer>
                <PlainGames />
            </GlobalContainer>

            <FooterComp />
        </>
    );
}
